import type { AssistantDialogMessage } from "../types";

/** Последние visible реплик раскрыты, ранние свёрнуты под «Показать весь диалог». */
export function splitDialog(
  messages: AssistantDialogMessage[],
  visible = 6
): { shown: AssistantDialogMessage[]; hidden: number } {
  if (messages.length <= visible) return { shown: messages, hidden: 0 };
  return {
    shown: messages.slice(messages.length - visible),
    hidden: messages.length - visible,
  };
}
